import type { BdrLeadDetailsProps } from './types'
import { BdrLeadDetailsIdentity } from './BdrLeadDetailsIdentity'
import { BdrLeadDetailsRegSection } from './BdrLeadDetailsRegSection'

type LeftProps = Pick<
  BdrLeadDetailsProps,
  | 'selectedLead'
  | 'getCadencia'
  | 'closers'
  | 'showRegTentativa'
  | 'setShowRegTentativa'
  | 'regTentativa'
  | 'setRegTentativa'
  | 'savingTentativa'
  | 'handleRegTentativa'
>

export function BdrLeadDetailsLeftPanel(props: LeftProps) {
  const cadencia = props.getCadencia(props.selectedLead.id)

  return (
    <div className="flex min-w-0 flex-col gap-5 lg:min-h-0">
      <BdrLeadDetailsIdentity selectedLead={props.selectedLead} cadencia={cadencia} />
      <BdrLeadDetailsRegSection
        selectedLead={props.selectedLead}
        closers={props.closers}
        showRegTentativa={props.showRegTentativa}
        setShowRegTentativa={props.setShowRegTentativa}
        regTentativa={props.regTentativa}
        setRegTentativa={props.setRegTentativa}
        savingTentativa={props.savingTentativa}
        handleRegTentativa={props.handleRegTentativa}
      />
    </div>
  )
}
